// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "pre[data-v-19359ccc]{background-color:#ffd;padding:.5rem;font-size:.7rem}small.error[data-v-19359ccc]{position:absolute;font-size:.6rem;line-height:.8rem;margin-top:.1rem;color:#c00}.form-group-error .form-control[data-v-19359ccc]:focus{border-color:red;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(255,0,0,.6)}.form-group-error .form-control[data-v-19359ccc]{background-color:#fee}", ""]);
// Exports
module.exports = exports;
